module.exports = "/images/FilledCookiePolicy.svg?e16e0953eee61e6c035e683fbcc712c6";